import * as React from 'react';
import { format } from 'date-fns';
import { Prompt } from 'react-router';
import { reduxForm, SubmissionError } from 'redux-form';
import { compose, withProps, lifecycle, withState, withHandlers } from 'recompose';
import { Card } from 'material-ui';
import * as uuid from 'uuid/v4';
import { connect } from 'react-redux';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';

import EntityDetailEnhancer from '@components/hoc/entityDetailEnhancer/EntityDetailEnhancer';

import { getRole, getPermissions, putPermissions } from '@modules/roles-create/_rolesCreateActions';
import * as T from '@modules/roles-create/_rolesCreateTypes';
import { RolesCreateFormBasic } from '@modules/roles-create/RolesCreateFormBasic';
import { Loader } from '@components/loader';
import { rolesCreateLabel, rolesCreatePath } from './RolesCreateGrid';

const enhance = compose<T.RolesFormProps, T.Outter>(
  connect(),
  withState('permissionsAvailable', 'setPermissionsAvailable', []),
  withState('permissionsAssigned', 'setPermissionsAssigned', []),
  withState('loader', 'setLoader', false),
  EntityDetailEnhancer<T.RolesEnhancerProps<T.Role>, T.Role>({
    getEntity: getRole,
    defaultEntity: {}
  }),
  lifecycle<any, any>({
    async componentDidMount() {
      const { setPermissionsAvailable, setPermissionsAssigned, setLoader, entity = { permissions: [] } } = this.props;
      setLoader(true);
      const permissionsAll = await getPermissions();
      const permissionsAssigned = permissionsAll.filter(item => {
        return entity.permissions.indexOf(item.id) !== -1;
      });
      const permissionsAvailable = permissionsAll.filter(item => {
        return entity.permissions.indexOf(item.id) === -1;
      });

      setPermissionsAvailable(permissionsAvailable);
      setPermissionsAssigned(permissionsAssigned);
      setLoader(false);
    }
  }),
  breadcrumbs(({ entity }) => [
    { label: rolesCreateLabel, to: rolesCreatePath },
    { label: entity && entity.id ? 'Upravit záznam' : 'Nový záznam' }
  ]),
  withProps<{}, T.RolesProps>(({ entity, permissionsAvailable, permissionsAssigned }) => ({
    initialValues: {
      permissionsAvailable,
      ...entity,
      permissionsAssigned
    },
    maxYear: format(new Date(), 'YYYY')
  })),
  withHandlers({
    onSubmit: ({ closeItem }) => async ({ permissionsAvailable, ...formData }) => {
      const modifiedPermissions = formData.permissionsAssigned.map(p => p.id);
      const modifiedData = { id: formData.id ? formData.id : uuid(), ...formData, permissions: modifiedPermissions };
      const response = await putPermissions(modifiedData);
      if (response) {
        closeItem();
      } else {
        throw new SubmissionError({
          _error: 'Nepodařilo se vygenerovat obálky'
        });
      }
    }
  }),
  reduxForm({
    keepDirtyOnReinitialize: true,
    enableReinitialize: true
  })
);

const View: React.SFC<T.Outter & T.RolesFormProps> = ({ handleSubmit, closeItem, error, loader, ...props }) => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    {loader && <Loader />}
    <form className="layout" onSubmit={handleSubmit}>
      <Card>
        <RolesCreateFormBasic {...props} />
        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
        {error && <div style={{ marginLeft: 'px', color: 'red' }}>{error}</div>}
      </Card>
    </form>
  </div>
);

export default enhance(View);



// WEBPACK FOOTER //
// ./src/modules/roles-create/RolesCreateForm.tsx